export const createArticleTopics = () => {
  document.querySelectorAll("h2[id^=article-section-h2-]").forEach(function (h2, i) {
      const div = document.createElement("div")
      div.id = `article-topic-${i}`
      const elementsToWrap = []
      let nextElement = h2.nextElementSibling
      while (nextElement && nextElement.tagName !== "H2") {
        elementsToWrap.push(nextElement)
        nextElement = nextElement.nextElementSibling
      }
      elementsToWrap.forEach(function (element) {
        div.appendChild(element)
      })
      h2.parentNode.insertBefore(div, h2.nextElementSibling)
      div.insertBefore(h2, div.firstChild)
    })
}
